import { create } from 'zustand';

export type UploadLeadershipStatus =
  | 'inactive'
  | 'initializing'
  | 'leader'
  | 'follower'
  | 'unsupported';

interface UploadLeadershipState {
  uid: string | null;
  status: UploadLeadershipStatus;
}

export const useUploadLeadershipStore = create<UploadLeadershipState>()(() => ({
  uid: null,
  status: 'inactive',
}));

export function setUploadLeadership(uid: string | null, status: UploadLeadershipStatus): void {
  useUploadLeadershipStore.setState({ uid, status });
}

export function isLocalUploadLeader(): boolean {
  return useUploadLeadershipStore.getState().status === 'leader';
}

class UploadLeaderRequiredError extends Error {
  constructor() {
    super('local_upload_active_in_another_tab');
    this.name = 'UploadLeaderRequiredError';
  }
}

export function requireLocalUploadLeader(): void {
  if (!isLocalUploadLeader()) throw new UploadLeaderRequiredError();
}
